
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/search-order",
      function () {
        return require("private-next-pages/search-order.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/search-order"])
      });
    }
  